import * as React from "react"
import { router } from "@inertiajs/react"
import { warehouses_path } from "@/lib/routes"
import { useMarket } from "@/lib/useMarket"
import { Button } from "@/components/ui/Button"
import { Input } from "@/components/ui/Input"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/Dialog"

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function CreateWarehouseDialog({ open, onOpenChange }: Props) {
  const market = useMarket()
  const [name, setName] = React.useState("")
  const [code, setCode] = React.useState("")
  const [externalId, setExternalId] = React.useState("")
  const [submitting, setSubmitting] = React.useState(false)

  React.useEffect(() => {
    if (!open) return
    setName("")
    setCode("")
    setExternalId("")
  }, [open])

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitting(true)
    router.post(
      warehouses_path(market.slug),
      {
        warehouse: {
          name,
          code,
          external_id: externalId,
        },
      },
      {
        onSuccess: () => onOpenChange(false),
        onFinish: () => setSubmitting(false),
      }
    )
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>New warehouse</DialogTitle>
          <DialogDescription>Manually add a warehouse to this org.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-5">
          <div className="flex flex-col gap-1">
            <label className="text-sm">Name</label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label className="text-sm">Code</label>
              <Input value={code} onChange={(e) => setCode(e.target.value)} />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm">External ID</label>
              <Input value={externalId} onChange={(e) => setExternalId(e.target.value)} required />
            </div>
          </div>

          {/* Channel links are set via the picker after creation — org_node_id is a
              frozen legacy column (see spec §3); do not reintroduce a node select. */}

          <div className="flex items-center justify-end pt-2">
            <Button type="submit" disabled={submitting}>Create</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
